import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { concatMap, map, shareReplay } from "rxjs/operators";
import { SharedService } from "./services/shared.service";
import { StorageService } from "src/app/core/helpers/storage.service";
import { environment } from "../../../../../environments/environment";
import { Config } from "../../../../core/Config";
import { DashboardData } from "../dashboard/model/dashboard-models";
import { AppUsage, configuredDeviceByDeviceTypeResponse, TransactionDashboardResponse } from "./models/business-dahsboard-details.model";

const BASE_URL = environment.BASE_URL;
@Injectable({
  providedIn: "root",
})
export class BusinessService {
  selectedBusiness: any;
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private storageService: StorageService,
    private sharedService: SharedService,
    private config: Config
  ) {
    this.sharedService.userData$.subscribe((res) => {
      this.selectedBusiness = res;
    });
  }

  createBusiness(busDetails: object) {
    return this.httpClient.post(
      BASE_URL + this.config.createBusiness,
      busDetails
    );
  }

  getSingleBusiness(id: number) {
    return this.httpClient.get(BASE_URL + this.config.getSingleBusiness + id);
  }
  updateBusiness(busDetails: object) {
    return this.httpClient.put(
      BASE_URL + this.config.updateBusiness,
      busDetails
    );
  }
  uploadLogo(logoDetails: object) {
    return this.httpClient.post(
      BASE_URL + this.config.uploadBusinessLogo,
      logoDetails
    );
  }
  uploadDocuments(docDetails: object) {
    return this.httpClient.post(
      BASE_URL + this.config.uploadBusinessDocuments,
      docDetails
    );
  }

  getBusinessDocuments(businessID: string) {
    return this.httpClient.get(
      BASE_URL + this.config.getBusinessDocuments + businessID
    );
  }
  getCommentHistory(businessID: string, limit) {
    return this.httpClient.get(
      BASE_URL + this.config.getCommentHistory + businessID + "&limit=" + limit
    );
  }
  getDashboardData(): Observable<DashboardData> {
    return this.httpClient.get<DashboardData>(
      BASE_URL + this.config.getDashboard
    ).pipe(
      map((res) => {
        return res;
      })
    )
  }
  getSuperAdminDashboardData(): Observable<DashboardData> {
    return this.httpClient.get<DashboardData>(
      BASE_URL + this.config.getSuperAdminDashboardData
    ).pipe(
      map((res) => {
        return res;
      })
    )
  }
  requestService(busDetails, id, service, env) {
    return this.httpClient
      .post(BASE_URL + this.config.requestService, busDetails)
      .pipe(
        concatMap((resp) =>
          this.httpClient
            .get<any[]>(
              `${BASE_URL}${this.config.getWalletBalance}?business_id=${id}&service=${service}&environment=${env}`
            )
            .pipe(map((res) => ({ response1: resp, response2: res })))
        )
      );
  }

  getBillPaymentKeys(id, service, env) {
    return this.httpClient.get(
      BASE_URL +
      `${this.config.getBillPaymentKeys}?businessId=${id}&service=${service}&environment=${env}`
    );
  }
  deleteKey(deletePayload) {
    return this.httpClient.post(
      BASE_URL + `${this.config.deleteBillPaymentKeys}`,
      deletePayload
    );
  }

  getWalletBalance(id, service, env) {
    return this.httpClient.get(
      BASE_URL +
      `${this.config.getWalletBalance}?business_id=${id}&service=${service}&environment=${env}`
    );
  }
  makeComment(comment) {
    return this.httpClient.post(BASE_URL + this.config.makeComment, comment);
  }

  canGoLive(id, service) {
    return this.httpClient.get(
      BASE_URL +
      `${this.config.checkLiveStatus}?business_id=${id}&service=${service}`
    );
  }

  getDevicePerModelType(): Observable<any> {
    return this.httpClient.get<any>(
      BASE_URL + this.config.getDevicePerModelType
    ).pipe(
      map((res) => {
        return res;
      })
    )
  }

  getWeeklyBoundDevice(startDate?: string, endDate?: string): Observable<any> {
    let params = new HttpParams();
    if (startDate) {
      params = params.append('startDate', startDate);
    }
    if (endDate) {
      params = params.append('endDate', endDate);
    }

    return this.httpClient.get<any>(
      BASE_URL + this.config.getBoundDevicePerWeek, { params }
    ).pipe(
      map((res) => {
        return res;
      })
    )
  }

  getWeeklyUnboundDevice(startDate?: string, endDate?: string): Observable<any> {
    let params = new HttpParams();
    if (startDate) {
      params = params.append('startDate', startDate);
    }
    if (endDate) {
      params = params.append('endDate', endDate);
    }

    return this.httpClient.get<any>(
      BASE_URL + this.config.getUnboundDevicePerWeek, { params }
    ).pipe(
      map((res) => {
        return res;
      })
    )
  }

  getAppUsage(clientId?: number): Observable<AppUsage[]> {
    return this.httpClient.get<AppUsage[]>(
      BASE_URL + '/v1/device/app-usage-summary'
    )
  }

  getConfiguredDevicesByDeviceType(days?: number): Observable<configuredDeviceByDeviceTypeResponse[]> {
    let params = new HttpParams();
    if (days) {
      params = params.append('days', days);
    }
    return this.httpClient.get<configuredDeviceByDeviceTypeResponse[]>(
      BASE_URL + '/v1/device/allConfiguredDevicesByDeviceTypeInLastDays', { params }
    ).pipe(
      shareReplay(),
    )
  }

}
